export default __webpack_public_path__ + "fd29759c1586ddb0b16618060dd45da9.png";